import { Link, Skeleton } from 'components/common';
import { QuickMenuOptions } from './types';

const QuickMenuView = ({ title, menus }: QuickMenuOptions) => {
  return (
    <div className="flex">
      <p className="tw-uppercase tw-tracking-wider tw-text-gray-500 tw-font-semibold tw-text-[13px] tw-mb-0">
        {title}
      </p>
      <div className="tw-divide-y">
        {menus.map(({ isLoading, items }) => (
          <>
            {isLoading ? (
              <div className="tw-py-4">
                {/* @ts-ignore */}
                <Skeleton options={{ numberOfLines: 6 }} />
              </div>
            ) : (
              <ul className="tw-text-[14px] tw-mb-0 tw-py-4 last:tw-pb-0">
                {items.map((item) => (
                  <li key={item.url}>
                    <Link
                      to={item.url}
                      target="_blank"
                      className="tw-block tw-px-2 tw-py-0.5 -tw-mx-2 tw-rounded-lg hover:tw-bg-gray-100 tw-transition tw-ease-in-out tw-duration-300 tw-font-medium"
                    >
                      <span>{item.label}</span>
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </>
        ))}
      </div>
    </div>
  );
};

export default QuickMenuView;
